function beforeScriptExecuteListener(evt) {
  if (node.getAttribute('type') === 'text/partytown') {
    evt.preventDefault();
  }
  node.removeEventListener('beforescriptexecute', beforeScriptExecuteListener);
}

(function () {
  try {
    const targetNode = document.getElementsByTagName('head')[0];
    const config = {attributes: true, childList: true, subtree: false};

    const callback = (mutationList, observer) => {
      for (const mutation of mutationList) {
        if (mutation.type === 'childList') {
          for (const addedNode of mutation.addedNodes) {
            if (
              addedNode.nodeType !== 1 ||
              addedNode.tagName !== 'SCRIPT' ||
              addedNode.classList.contains('boostly-skip')
            ) {
              continue;
            }

            // Trekkie
            if (window.theme?.boostly?.isBoostlyTrekkieEnabled) {
              if (!addedNode.getAttribute('src') && addedNode.classList.contains('analytics')) {
                addedNode.type = 'text/partytown';
                addedNode.addEventListener('beforescriptexecute', beforeScriptExecuteListener);
              }
              if (
                !addedNode.getAttribute('src') &&
                !addedNode.classList.contains('analytics') &&
                addedNode.textContent.includes('ShopifyAnalytics')
              ) {
                const firstScript = document.getElementsByTagName('script')[0];
                const newScript = document.createElement('script');
                newScript.type = 'text/javascript';
                newScript.classList.add('boostly-skip');
                newScript.text = addedNode.textContent;
                firstScript.parentNode.insertBefore(newScript, firstScript);
                addedNode.type = 'text/partytown';
                addedNode.addEventListener('beforescriptexecute', beforeScriptExecuteListener);
              }
            }

            // Add here trackings where we can't manually add the type text/partytown
            const supportedTrackers = [];
            if (window.theme?.boostly?.isBoostlyKlaviyoEnabled) supportedTrackers.push('klaviyo');

            if (
              supportedTrackers.some((tracker) => addedNode.getAttribute('src')?.includes(tracker))
            ) {
              addedNode.type = 'text/partytown';
              addedNode.addEventListener('beforescriptexecute', beforeScriptExecuteListener);
            }
          }
        }
      }
    };

    const observer = new MutationObserver(callback);
    observer.observe(targetNode, config);
  } catch (e) {
    console.error(e);
  }
})();
